// extracted by mini-css-extract-plugin
export default {"features":"features-block_features__UoZ9z","vacancies":"features-block_vacancies__HaEI1"};